<template>
    <div class="page-exam-room">
        <vue-headful 
            :title="$PPlusEngine.getDictionary($route.params.lang, 
                'ห้องสอบ - ProbPlus', 
                'Exam - ProbPlus')" 
            :description="$PPlusEngine.getDictionary($route.params.lang, 
                'สนามสอบวัดผลเพื่อขอใบรับรองโดยปปง.',
                'Exam to test your knowledge for getting certified by AMLO')" />
        <ContentLoader :isDisplay="!contentReady" />
        <div class="exam-sheet" v-if="page == 1">
            <template v-if="contentReady">
                <div class="countdown">{{ $PPlusEngine.getDictionary($route.params.lang, 'เวลาทำข้อสอบ', 'Time Remaining') }} <label>{{ displayCountDown(countDown) }}</label></div>
                <div class="quick-guide" :class="{ 'hide': !isShowQuickGuide }">
                    <div class="wrapper">
                        <button class="toggle" @click="isShowQuickGuide = !isShowQuickGuide"><i class="pe-7s-angle-right"></i></button>
                        <button v-scroll-to="{ el: '#question1', offset: -120 }"><font-awesome-icon :icon="['fas', 'pencil-alt']" /> 1 - 10</button>
                        <button v-scroll-to="{ el: '#question11', offset: -120 }"><font-awesome-icon :icon="['fas', 'pencil-alt']" /> 11 - 20</button>
                        <button v-scroll-to="{ el: '#question21', offset: -120 }"><font-awesome-icon :icon="['fas', 'pencil-alt']" /> 21 - 30</button>
                        <button v-scroll-to="{ el: '#question31', offset: -120 }"><font-awesome-icon :icon="['fas', 'pencil-alt']" /> 31 - 40</button>
                        <button v-scroll-to="{ el: '#question41', offset: -120 }"><font-awesome-icon :icon="['fas', 'pencil-alt']" /> 41 - 50</button>
                    </div>
                </div>
                <div class="container">
                    <div class="global-box-content">
                        <h1><i class="pe-7s-news-paper"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'ข้อสอบ', 'Exam') }}</h1>
                        <ExamQuestion v-for="(item, index) in fieldsExam" :key="index" :fields="item" @selectedChoice="selectChoice" />
                    </div>
                    <div class="action">
                        <button class="btn btn-main" @click="finish()">{{ $PPlusEngine.getDictionary($route.params.lang, 'ทำเสร็จแล้ว', 'Finish Exam') }}</button>
                    </div>
                </div>
            </template>
        </div>
        <div class="exam-result" v-if="page == 2">
            <template v-if="contentReady">
                <div class="container">
                    <section class="board">
                        <div class="global-box-content">
                            <h1>{{ $PPlusEngine.getDictionary($route.params.lang, 'สรุปผลการสอบ', 'Your Exam Result') }}</h1>
                            <div class="result" :class="{ 'pass': fieldsResult.result, 'fail': !fieldsResult.result }">
                                {{ fieldsResult.percent }}%
                            </div>
                            <article v-if="fieldsResult.result" class="pass">
                                <template v-if="$route.params.lang == 'th'">
                                    ยินดีด้วยท่านได้<u>ผ่าน</u>การสอบวัดผลเป็นที่เรียบร้อยแล้ว
                                    <br />
                                    ท่านสามารถดาวน์โหลดเอกสารรับรองโดยปปง โดยการคลิกที่ <router-link :to="'/' + $route.params.lang + '/user/certificate'">Link</router-link> นี้
                                </template>
                                <template v-if="$route.params.lang == 'en'">
                                    Congratulation! You already <u>passed</u> the exam
                                    <br />
                                    You can download your certification from this <router-link :to="'/' + $route.params.lang + '/user/certificate'">Link</router-link>
                                </template>
                            </article>
                            <article v-if="!fieldsResult.result" class="fail">
                                <template v-if="$route.params.lang == 'th'">
                                    เสียใจด้วยท่านยัง<u>ไม่ผ่าน</u>เกณฑ์การสอบวัดผล (70%) ในรอบนี้
                                    <br />
                                    ท่านสามารถกลับไปทบทวนบทเรียน และสอบใหม่อีกครั้งได้
                                </template>
                                <template v-if="$route.params.lang == 'en'">
                                    Sorry, you haven't passed 70% of the exam score
                                    <br />
                                    You can review and learn the lessons to take the exam again
                                </template>
                            </article>
                            <div class="stat">
                                <div class="row">
                                    <div class="col-12 col-sm-6">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'คะแนนที่ได้', 'Score') }}</label>
                                        <span>{{ fieldsResult.score }}</span>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'คะแนนเต็ม', 'Maximum') }}</label>
                                        <span>{{ fieldsResult.max }}</span>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, '% ความถูกต้อง', '% Correct') }}</label>
                                        <span>{{ fieldsResult.percent }}%</span>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'สอบครั้งที่', 'Exam Round') }}</label>
                                        <span>{{ fieldsResult.attemp }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="action">
                                <router-link :to="'/' + $route.params.lang + '/user/certificate'" class="btn btn-main" v-if="fieldsResult.result">{{ $PPlusEngine.getDictionary($route.params.lang, 'ดาวน์โหลดใบรับรอง', 'Download Certificate') }}</router-link>
                                <router-link :to="'/' + $route.params.lang + '/course'" class="btn btn-main" v-if="!fieldsResult.result">{{ $PPlusEngine.getDictionary($route.params.lang, 'ดูบทเรียน', 'Course') }}</router-link>
                                <router-link :to="'/' + $route.params.lang" class="btn btn-main-o">{{ $PPlusEngine.getDictionary($route.params.lang, 'กลับสู่หน้าแรก', 'Back to Main') }}</router-link>
                            </div>
                        </div>
                    </section>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import ContentLoader from '@/weact/components/ContentLoader';
import ExamQuestion from '@/components/ExamQuestion';

export default {
    components: {
        ContentLoader,
        ExamQuestion
    },
    data() {
        return {
            contentReady: false,
            fieldsExam: {},
            fieldsResult: {},
            answers: [],
            isShowQuickGuide: true,
            skipQuestionIds: [],
            page: 1,
            countDown: 0,
            isSubmit: false
        }
    },
    created() {
        setTimeout(() => {
            this.getContent();
        }, this.$WeConfig.TimeLoader);
    },
    methods: {
        getContent() {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {};

            this.$WeHelper.postAPI(apiURL, '/api/exam/get-content', postData, this.$PPlusEngine.getHeaderToken()).then((response) => {
                if (response.data.allow) {
                    this.fieldsExam = response.data.question;
                    this.answers = new Array(response.data.question.length);
                    this.countDown = response.data.remainingTime;
                    this.isSubmit = false;
                    this.countDownTimer();
                    this.checkSelectedChoices(response.data.question);
                    this.contentReady = true;
                }
                else {
                    this.$router.push('/' + this.$route.params.lang + '/exam');
                }
            });
        },
        selectChoice(data) {
            this.answers[data.questionNumber - 1] = data;

            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {
                questionId: data.questionId,
                answerId: data.choiceId
            };

            this.$WeHelper.postAPI(apiURL, '/api/exam/select-choice', postData, this.$PPlusEngine.getHeaderToken()).then(() => {});
        },
        finish() {
            if (!this.isAllQuestionSelected()) {
                this.$swal({
                    title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'ตอบคำถามยังไม่ครบ', 
                                        'Incompleted Answers'),
                    html: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'ท่านยังไม่ได้ตอบคำถามข้อ<br /><br /><b>' + this.skipQuestionIds.join(', ') + '</b><br /><br />ท่านยังยืนยันที่จะส่งคำตอบหรือไม่', 
                                        'You haven\'t yet answer the question no.<br /><br /><b>' + this.skipQuestionIds.join(', ') + '</b><br /><br />Please confirm if you would like to finish your exam'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#cc4a4e',
                    cancelButtonColor: '#ccc',
                    confirmButtonText: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'ไม่เป็นไร ขอส่งคำตอบ', 
                                        'Ok, Submit')
                }).then((result) => {
                    if (result.value) {
                        this.submitExam({ isTimeout: false });
                    }
                });
            } else {
                this.$swal({
                    title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'ยืนยันการส่งคำตอบ', 
                                        'Confirm All Answer'),
                    text: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'ท่านต้องการส่งคำตอบเลยหรือไม่', 
                                        'Please confirm if you would like to finish your exam'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#cc4a4e',
                    cancelButtonColor: '#ccc',
                    confirmButtonText: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'ส่งคำตอบ', 
                                        'Confirm'),
                }).then((result) => {
                    if (result.value) {
                        this.submitExam({ isTimeout: false });
                    }
                });
            }
        },
        isAllQuestionSelected() {
            this.skipQuestionIds = [];

            for (var i = 0; i < this.answers.length; i++) {
                if (this.answers[i] == null) {
                    this.skipQuestionIds.push(i + 1);
                }
            }

            return this.skipQuestionIds.length == 0;
        },
        submitExam(param) {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = { answers: this.answers };

            this.contentReady = false;

            this.$WeHelper.postAPI(apiURL, '/api/exam/get-result', postData, this.$PPlusEngine.getHeaderToken()).then((response) => {
                this.isSubmit = true;

                this.fieldsResult = response.data;

                if (param.isTimeout) {
                    let timerInterval;
                    let page = this;

                    this.$swal({
                        title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'เวลาสอบได้หมดลงแล้ว', 
                                        'Time\'s Up!'),
                        html: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'คำตอบของท่านกำลังถูกส่งไปตรวจสอบที่ระบบ กรุณาอย่าปิดหน้านี้ ระบบจะแสดงผลข้อสอบในอีก <span>5</span> วินาที', 
                                        'Your answers are going to get reviewed by the system. Please do not close your window. Your will get your exam result within <span>5</span> second(s)'),
                        timer: 5000,
                        type: 'success',
                        confirmButtonText: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'รับทราบ',
                                        'OK'),
                        onBeforeOpen: () => {
                            timerInterval = setInterval(() => {
                                page.$swal.getContent().querySelector('span').textContent = Math.ceil(page.$swal.getTimerLeft() / 1000)
                            }, 1000)
                        },
                        onClose: () => {
                            clearInterval(timerInterval);
                            let loader = this.$WeHelper.modalLoad();
                            this.page = 2;
                            this.contentReady = true;
                            loader.hide();
                        }
                    });
                } else {
                    this.page = 2;
                    this.contentReady = true;
                }
            });
        },
        countDownTimer() {
            if (this.countDown > 0) {
                if (!this.isSubmit) {
                    setTimeout(() => {
                        this.countDown -= 1
                        this.countDownTimer()
                    }, 1000);
                }
            } else if (!this.submitExam) {
                this.submitExam({ isTimeout: true });
            }
        },
        displayCountDown(time) {
            var hour = Math.floor(time / 3600);
            time %= 3600;
            var min = Math.floor(time / 60);
            var sec = time % 60;

            return hour + ':' + ('0' + min).slice(-2) + ':' + ('0' + sec).slice(-2);
        },
        checkSelectedChoices(questions) {
            for (var i = 0; i < questions.length; i++) {
                if (questions[i].selectedChoiceId) {
                    this.answers[i] = {
                        questionId: questions[i].id,
                        choiceId: questions[i].selectedChoiceId
                    };
                }
            }
        }
    }
};
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-exam-room {
    .countdown {
        position: fixed;
        z-index: 1;
        top: 80px;
        left: 50%;
        margin-left: -70px;
        padding: 5px 10px;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
        font-size: 12px;
        color: #ddd;
        @include borderRadius(1000px);

        label {
            color: #fff;
            margin: 0;
            margin-left: 5px;
        }
    }

    .quick-guide {
        position: fixed;
        z-index: 1;
        right: 0;
        top: 40%;
        padding: 5px 10px;
        background: rgba(0, 0, 0, 0.65);
        text-align: center;

        &.hide {
            right: -79px;
        }

        .wrapper {
            position: relative;
        }

        .toggle {
            position: absolute;
            background: rgba(0, 0, 0, 0.65);
            border: none;
            border-right: 1px solid #999;
            z-index: 1;
            color: #fff;
            width: 22px;
            height: 30px;
            top: 0;
            left: -32px;

            i {
                font-size: 20px;
                line-height: 20px;
                display: block;
                text-align: center;
                margin: 0;
                color: #fff;
            }
        }

        button {
            display: block;
            width: 100%;
            background: none;
            border: none;
            border-bottom: 1px solid #999;
            font-size: 10px;
            color: #fff;
            padding: 5px 0;
            outline: none;
            text-align: left;

            &:last-child {
                border-bottom: none;
            }

            svg {
                font-size: 10px;
                line-height: 10px;
                margin-right: 8px;
                color: #bbb;
                @include verticalAlign(middle);
            }
        }
    }

    .exam-sheet {
        padding: 40px 0;

        h1 {
            font-size: 32px;
            font-weight: 200;
            margin: 0;
            padding-bottom: 40px;
            color: #666;

            i {
                @include verticalAlign(middle);
                color: #aaa;
                margin-right: 5px;
            }

            &:after {
                margin-top: 12px;
                width: 100px;
                height: 1px;
                background: $mainColor;
                display: block;
                content: " ";
            }
        }

        .action {
            margin-top: 20px;
            text-align: center;

            .btn {
                margin: 0 5px;
            }
        }
    }
    
    .exam-result {
        padding: 80px 0;
        background-image: url(../assets/exam-result-bg.jpg);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;

        .board {
            text-align: center;

            h1 {
                font-size: 32px;
                font-weight: 200;
                color: #a2bfc3;
                margin: 0;
                padding-bottom: 15px;

                &:after {
                    content: " ";
                    display: block;
                    width: 100px;
                    height: 1px;
                    background: #ccc;
                    margin: 15px auto 0;
                }
            }

            .result {
                font-size: 72px;

                &.pass {
                    color: #21b58d;
                }

                &.fail {
                    color: #cc0000;
                }
            }

            article {
                font-size: 15px;
                color: #666;
                padding-top: 20px;
                margin: 0;

                &.pass {
                    u {
                        color: #21b58d;
                    }
                }

                &.fail {
                    u {
                        color: #cc0000;
                    }
                }
            }

            .stat {
                max-width: 500px;
                margin: 30px auto 0;
                border: 1px dashed #e7e7e7;
                padding: 20px;
                text-align: left;

                label {
                    @include verticalAlign(middle);
                    width: 130px;
                    margin: 5px 0;
                    font-size: 15px;
                    padding-right: 15px;
                    color: #bbb;
                    text-align: right;
                }

                span {
                    @include verticalAlign(middle);
                    font-size: 17px;
                    color: #000;
                }
            }

            .action {
                margin-top: 40px;

                .btn {
                    margin: 0 5px;
                }
            }
        }
    }
}
</style>